import React from 'react'
import Grid from "@material-ui/core/Grid";
import { useStyle } from "./Style";
import { getPartner } from '../../../../../lib/access.es6';
import { formatDateLocale } from '../../../../../lib/utils.es6';
import { describeMedicalConditions } from '../../../../../lib/personDetails.es6';
import {
  applyBenefitCaps,
  declaredConditionForMember
} from '../../../../../lib/claimBenefitCaps.es6';

const ClaimDetails = (props) => {

  console.log("claim details props", props)



  //hospital details
  const claimant_full_name = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.claimant_full_name
    : "N/A";

  const claimant_phone_number = props.claim.claim_details.claimant_msisdn
    ? props.claim.claim_details.claimant_msisdn
    : "N/A";

  const claimant_id_number = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.claimant_id_number
    : "N/A";

  const claimant_relationship_to_patient = props.claim.claim_details
    .additional_details
    ? props.claim.claim_details.additional_details
        .claimant_relationship_to_patient
    : "N/A";

  const patientAge = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.age
    : "N/A";

  const admission_date = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.admission_date
    : "N/A";

  const discharge_date = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.discharge_date
    : "N/A";

  const number_of_days_in_hospital = props.claim.claim_details
    .additional_details
    ? props.claim.claim_details.additional_details.number_of_days_in_hospital
    : "N/A";

  //death details
  const claimant_full_name_death = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.claimant_full_name
    : "N/A";

  const claimant_id_number_death = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.claimant_id_number
    : "N/A";

  const claimant_relationship_to_patient_death = props.claim.claim_details
    .additional_details
    ? props.claim.claim_details.additional_details
        .claimant_relationship_to_patient
    : "N/A";

  // Use the claim's own currency; fall back to the partner country currency.
  const currencyCode =
    (props.claim && props.claim.currency) || getPartner().country.currency_code;



  const funeral_home_name = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.funeral_home_name
    : "N/A";

  const death_certficate_number = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.death_certficate_number
    : "N/A";
    const burial_certificate_number = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.burial_certificate_number
    : "N/A";

  // Retest item 12: the exact cause — the specific illness or the nature of the
  // accident — is captured on both journeys but was never shown to the assessor.
  const cause_of_death_detail = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.cause_of_death_detail
    : "";

  // Retest item 18: an assessor could not see that the deceased was declared with a
  // medical condition, which is what triggers the first-year benefit cap.
  //
  // Read through the shared reader rather than off the dependant: OMK captures the
  // declaration on the POLICY (medical_pre_condition plus a list naming the members
  // it applies to) and never on the dependant, so looking only at
  // dependant.additional_details told every assessor "None declared".
  const deceasedDependant =
    (props.claim.member && props.claim.member.dependant) || {};
  const condition = declaredConditionForMember(
    deceasedDependant,
    props.policy,
    props.claim.claim_details.additional_details
  );
  const declaredMedicalCondition = condition.declared;
  // Four outcomes, and an assessor needs to tell them apart: the named conditions,
  // declared but unnamed, declared on the policy against nobody in particular, and
  // nothing declared at all. Built once and rendered by each of the three claim
  // layouts below, so they cannot drift.
  const declaredConditionText = condition.declared
    ? describeMedicalConditions(condition.conditions, true)
    : condition.declaredOnPolicy
      ? 'Declared on the policy — this member not named'
      : 'None declared';
  const highlightCondition = condition.declared || condition.declaredOnPolicy;

  // Retest items 17/18: what is actually payable after the BRD §5.7 claims-time caps.
  const registeredBenefit =
    props.claim.benefits && props.claim.benefits.length
      ? props.claim.benefits[0].max_benefit_amount_in_cents / 100
      : 0;
  const benefitCap = applyBenefitCaps({
    benefitAmount: registeredBenefit,
    relationship:
      props.claim.claim_details.relationship_to_policyholder ||
      deceasedDependant.relationship,
    dateOfBirth:
      props.claim.claim_details.dependant_dob || deceasedDependant.date_of_birth,
    dateOfDeath: props.claim.event_date,
    declaredMedicalCondition: declaredMedicalCondition,
    causeOfDeath: (props.claim.claim_details.additional_details || {})
      .cause_of_death,
    coverStartDate:
      (props.claim.benefits && props.claim.benefits.length
        ? props.claim.benefits[0].waiting_period_start_date
        : null) ||
      (props.claim.claim_details.additional_details || {}).policy_start_date
  });

  const classes = useStyle();

  if (!props.claim.claim_details) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} className={classes.claimwrapper}>
          <Grid container spacing={2} className={classes.claimdetailswrapper}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={classes.ClaimDetailscontent}
            >
              <p style={{ textAlign: "center" }}>No details found</p>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }


  return (
    <>
      <>
        {props.isHospiCashIllnessBenefitClaim(props.claim) ||
         props.isHospiCashAccidentBenefitClaim(props.claim) ? (
          <>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.claimwrapper}
              >
                <Grid
                  container
                  spacing={2}
                  className={classes.claimdetailswrapper}
                >
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Policy Holder Full Names</h4>
                    <p>
                      {props.claim.claim_details.policy_holder_fullname ||
                        "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Policy Holder Number</h4>
                    <p>
                      {props.claim.claim_details.policy_holder_msisdn || "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Full Name</h4>
                    <p>{claimant_full_name}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Claimant Phone Number</h4>
                    <p>{claimant_phone_number|| "N/A"}</p>
                  </Grid>
                  <div className={classes.borderbottom}></div>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant ID Number</h4>
                    <p>{claimant_id_number || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>claimant Relationship To Patient</h4>
                    <p>{claimant_relationship_to_patient}</p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4> Patient Full Name</h4>
                    <p>
                      {props.claim.claim_details.dependant_fullname || "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Patient D.O.B</h4>
                    <p>
                      {formatDateLocale(
                        props.claim.claim_details.dependant_dob
                      ) || "N/A"}
                    </p>
                  </Grid>

                  <div className={classes.borderbottom}></div>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Patient National ID</h4>
                    <p>
                      {props.claim.claim_details.dependant_national_id || "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Patient Age</h4>
                    <p>{patientAge}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Relationship To Policyholder</h4>
                    <p>
                      {props.claim.claim_details.relationship_to_policyholder ||
                        "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Admission Date</h4>
                    <p>{formatDateLocale(admission_date)}</p>
                  </Grid>
                  {/* <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontentlast}>
                  <h4>Gender</h4>
                  <p>{props.claim.claim_details.gender || "N/A"}</p>
                </Grid> */}
                  <div className={classes.borderbottom}></div>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Discharge Date</h4>
                    <p>{formatDateLocale(discharge_date)}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Number Of Days In Hospital </h4>
                    <p>{number_of_days_in_hospital}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Hospital Attended</h4>
                    <p>
                      {props.claim.claim_details.additional_details
                        .hospital_attended || "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Cause Of Hospitilization</h4>
                    <p>
                      {props.claim.claim_details.additional_details
                        .cause_of_hospitilization || "N/A"}
                    </p>
                  </Grid>
                  <div className={classes.borderbottom}></div>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Inpatient Number</h4>
                    <p>
                      {props.claim.claim_details.additional_details
                        .inpatient_number || "N/A"}
                    </p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Agent Name</h4>
                    <p>{props.claim.web_agent_name || "N/A"}</p>
                  </Grid>
                  {/* <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontentlast}>
                  <h4>Gender</h4>
                  <p>{props.claim.claim_details.gender || "N/A"}</p>
                </Grid> */}
                  <div className={classes.borderbottom}></div>
                </Grid>

              </Grid>
            </Grid>
          </>
        ) : props.isFuneralAccidentalDeathClaim(props.claim) ||
          props.isFuneralNaturalClaim(props.claim) ? (
          <>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.claimwrapper}
              >
                <Grid
                  container
                  spacing={2}
                  className={classes.claimdetailswrapper}
                >
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Deceased Names</h4>
                    <p>
                      {props.claim.claim_details.dependant_fullname || "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Relation to Principal</h4>
                    <p>
                      {props.claim.claim_details.relationship_to_policyholder ||
                        "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Gender</h4>
                    <p>{props.claim.claim_details.gender || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Deceased Date of Birth</h4>
                    <p>
                      {formatDateLocale(
                        props.claim.claim_details.dependant_dob
                      ) || "N/A"}
                    </p>
                  </Grid>
                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4> Date of Death</h4>
                    <p>{formatDateLocale(props.claim.event_date) || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4> Deceased Age</h4>
                    <p>
                      {props.claim.claim_details.additional_details.age ||
                        "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Cause of Death </h4>
                    <p>
                      {props.claim.claim_details.additional_details
                        .cause_of_death || "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Exact Cause of Death </h4>
                    <p>{cause_of_death_detail || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Declared Medical Condition </h4>
                    <p style={{ color: highlightCondition ? '#8F191C' : undefined }}>
                      {declaredConditionText}
                    </p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Benefit Amount </h4>
                    <p>
                      {`${currencyCode} ${(
                        props.claim.benefits[0].max_benefit_amount_in_cents /
                        100
                      ).toLocaleString()}` || "N/A"}
                    </p>
                    {benefitCap.capped && (
                      <p style={{ color: '#8a5300', fontSize: '11px', margin: 0 }}>
                        Payable: {currencyCode} {benefitCap.payable.toLocaleString()} —{' '}
                        {benefitCap.reason}
                      </p>
                    )}
                  </Grid>

                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Full Name </h4>
                    <p>{claimant_full_name_death}</p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant ID Number </h4>
                    <p>{claimant_id_number_death}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Phone Number </h4>
                    <p>{claimant_phone_number}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Claimant Relationship </h4>
                    <p>{claimant_relationship_to_patient_death}</p>
                  </Grid>
                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Email </h4>
                    <p>
                      {
                        props.claim.claim_details.claimant_email
                      }
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Payment Option </h4>
                    <p>
                      {
                        props.claim.claim_details.additional_details
                          .claimant_payment_option
                      }
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Payment Details </h4>
                    {props.claim.claim_details.additional_details
                      .claimant_payment_option === "Mpesa" && (
                      <p>
                        {
                          props.claim.claim_details.additional_details
                            .claimant_mpesa_phone_number
                        }
                      </p>
                    )}
                    {props.claim.claim_details.additional_details
                      .claimant_payment_option === "Bank" && (
                      <>
                        <p>
                          {
                            props.claim.claim_details.additional_details
                              .claimant_bank_name
                          }
                        </p>
                        <p>
                          {
                            props.claim.claim_details.additional_details
                              .claimant_bank_account_number
                          }
                        </p>
                      </>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Funeral Home Name </h4>
                    <p>{funeral_home_name}</p>
                  </Grid>
                  <div className={classes.borderbottom}></div>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Death Certficate Number </h4>
                    <p>{death_certficate_number}</p>
                  </Grid>
                    <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Burial Certficate Number </h4>
                    <p>{burial_certificate_number}</p>
                  </Grid>
                  <div className={classes.borderbottom}></div> 
                </Grid>
              </Grid>

            </Grid>
          </>
        ) : props.isDeathClaim(props.claim) ? (
          <>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.claimwrapper}
              >
                <Grid
                  container
                  spacing={2}
                  className={classes.claimdetailswrapper}
                >
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Deceased Names</h4>
                    <p>
                      {props.claim.claim_details.dependant_fullname || "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Relation to Principal</h4>
                    <p>
                      {props.claim.claim_details.relationship_to_policyholder ||
                        "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Gender</h4>
                    <p>{props.claim.claim_details.gender || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Deceased Date of Birth</h4>
                    <p>
                      {formatDateLocale(
                        props.claim.claim_details.dependant_dob
                      ) || "N/A"}
                    </p>
                  </Grid>
                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4> Date of Death</h4>
                    <p>{formatDateLocale(props.claim.event_date) || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4> Deceased Age</h4>
                    <p>
                      {props.claim.claim_details.additional_details.age ||
                        "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Cause of Death </h4>
                    <p>
                      {props.claim.claim_details.additional_details
                        .cause_of_death || "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Exact Cause of Death </h4>
                    <p>{cause_of_death_detail || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Declared Medical Condition </h4>
                    <p style={{ color: highlightCondition ? '#8F191C' : undefined }}>
                      {declaredConditionText}
                    </p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Benefit Amount </h4>
                    <p>
                      {`${currencyCode} ${(
                        props.claim.benefits[0].max_benefit_amount_in_cents /
                        100
                      ).toLocaleString()}` || "N/A"}
                    </p>
                    {benefitCap.capped && (
                      <p style={{ color: '#8a5300', fontSize: '11px', margin: 0 }}>
                        Payable: {currencyCode} {benefitCap.payable.toLocaleString()} —{' '}
                        {benefitCap.reason}
                      </p>
                    )}
                  </Grid>

                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Full Name </h4>
                    <p>{claimant_full_name_death}</p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant ID Number </h4>
                    <p>{claimant_id_number_death}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Phone Number </h4>
                    <p>{claimant_phone_number}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Claimant Relationship </h4>
                    <p>{claimant_relationship_to_patient_death}</p>
                  </Grid>
                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Email </h4>
                    <p>
                      {
                        props.claim.claim_details.claimant_email
                      }
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Payment Option </h4>
                    <p>
                      {
                        props.claim.claim_details.additional_details
                          .claimant_payment_option
                      }
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Payment Details </h4>
                    {props.claim.claim_details.additional_details
                      .claimant_payment_option === "Mpesa" && (
                      <p>
                        {
                          props.claim.claim_details.additional_details
                            .claimant_mpesa_phone_number
                        }
                      </p>
                    )}
                    {props.claim.claim_details.additional_details
                      .claimant_payment_option === "Bank" && (
                      <>
                        <p>
                          {
                            props.claim.claim_details.additional_details
                              .claimant_bank_name
                          }
                        </p>
                        <p>
                          {
                            props.claim.claim_details.additional_details
                              .claimant_bank_account_number
                          }
                        </p>
                      </>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Funeral Home Name </h4>
                    <p>{funeral_home_name}</p>
                  </Grid>
                  <div className={classes.borderbottom}></div>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Death Certficate Number </h4>
                    <p>{death_certficate_number}</p>
                  </Grid>
                   
                 
                </Grid>
              </Grid>

            </Grid>
          </>
        ) : 

        props.isOldMutualMalawiFuneralClaim(props.claim) ? (
          <>
         
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.claimwrapper}
              >
                <Grid
                  container
                  spacing={2}
                  className={classes.claimdetailswrapper}
                >
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Deceased Names</h4>
                    <p>
                      {props.claim.claim_details.dependant_fullname || "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Relation to Principal</h4>
                    <p>
                      {props.claim.claim_details.relationship_to_policyholder ||
                        "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Gender  </h4>
                    <p>{props.claim.claim_details.gender  || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Deceased Date of Birth</h4>
                    <p>
                      {formatDateLocale(
                        props.claim.claim_details.dependant_dob
                      ) || "N/A"}
                    </p>
                  </Grid>
                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4> Date of Death</h4>
                    <p>{formatDateLocale(props.claim.event_date) || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4> Deceased Age</h4>
                    <p>
                      {props.claim.claim_details.additional_details.age ||
                        "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Cause of Death </h4>
                    <p>
                      {props.claim.claim_details.additional_details
                        .cause_of_death || "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Exact Cause of Death </h4>
                    <p>{cause_of_death_detail || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Declared Medical Condition </h4>
                    <p style={{ color: highlightCondition ? '#8F191C' : undefined }}>
                      {declaredConditionText}
                    </p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Benefit Amount </h4>
                    <p>
                     {
  props.claim.benefits && props.claim.benefits.length
    ? currencyCode +
      " " +
      (
        props.claim.benefits.reduce(function (total, benefit) {
          return total + (benefit.max_benefit_amount_in_cents || 0);
        }, 0) / 100
      ).toLocaleString()
    : "N/A"
}
                    </p>
                  </Grid>

                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Full Name </h4>
                    <p>{claimant_full_name_death}</p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant ID Number </h4>
                    <p>{claimant_id_number_death}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Phone Number </h4>
                    <p>{claimant_phone_number}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Claimant Relationship </h4>
                    <p>{claimant_relationship_to_patient_death}</p>
                  </Grid>
                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Email </h4>
                    <p>
                      {
                        props.claim.claim_details.claimant_email
                      }
                    </p>
                  </Grid>


                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Funeral Home Name </h4>
                    <p>{funeral_home_name}</p>
                  </Grid>

                  <div className={classes.borderbottom}></div>
                </Grid>
              </Grid>
            </Grid>
          </>
        ) :  props.isDisabilityClaim(props.claim) ? (
             <>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.claimwrapper}
              >
                <Grid
                  container
                  spacing={2}
                  className={classes.claimdetailswrapper}
                >
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Disabled Names</h4>
                    <p>
                      {props.claim.claim_details.dependant_fullname || "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Relation to Principal</h4>
                    <p>
                      {props.claim.claim_details.relationship_to_policyholder ||
                        "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Gender</h4>
                    <p>{props.claim.claim_details.gender || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Disabled Date of Birth</h4>
                    <p>
                      {formatDateLocale(
                        props.claim.claim_details.dependant_dob
                      ) || "N/A"}
                    </p>
                  </Grid>
                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4> Date of Disability</h4>
                    <p>{formatDateLocale(props.claim.event_date) || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4> Disabled Age</h4>
                    <p>
                      {props.claim.claim_details.additional_details.age ||
                        "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Type of Disability</h4>
                    <p>
                      {props.claim.claim_details.additional_details
                        .type_of_disability || "N/A"}
                    </p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Benefit Amount </h4>
                    <p>
                      {`${currencyCode} ${(
                        props.claim.benefits[0].max_benefit_amount_in_cents /
                        100
                      ).toLocaleString()}` || "N/A"}
                    </p>
                    {benefitCap.capped && (
                      <p style={{ color: '#8a5300', fontSize: '11px', margin: 0 }}>
                        Payable: {currencyCode} {benefitCap.payable.toLocaleString()} —{' '}
                        {benefitCap.reason}
                      </p>
                    )}
                  </Grid>

                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Full Name </h4>
                    <p>{claimant_full_name_death}</p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant ID Number </h4>
                    <p>{claimant_id_number_death}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Phone Number </h4>
                    <p>{claimant_phone_number}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Claimant Relationship </h4>
                    <p>{claimant_relationship_to_patient_death}</p>
                  </Grid>
                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Email </h4>
                    <p>
                      {
                        props.claim.claim_details.claimant_email
                      }
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Payment Option </h4>
                    <p>
                      {
                        props.claim.claim_details.additional_details
                          .claimant_payment_option
                      }
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Payment Details </h4>
                    {props.claim.claim_details.additional_details
                      .claimant_payment_option === "Mpesa" && (
                      <p>
                        {
                          props.claim.claim_details.additional_details
                            .claimant_mpesa_phone_number
                        }
                      </p>
                    )}
                    {props.claim.claim_details.additional_details
                      .claimant_payment_option === "Bank" && (
                      <>
                        <p>
                          {
                            props.claim.claim_details.additional_details
                              .claimant_bank_name
                          }
                        </p>
                        <p>
                          {
                            props.claim.claim_details.additional_details
                              .claimant_bank_account_number
                          }
                        </p>
                      </>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Attending Physician</h4>
                    <p>{props.claim.claim_details.additional_details.attending_physician}</p>
                  </Grid>
                  
                  <div className={classes.borderbottom}></div>
                </Grid>
              </Grid>

            </Grid>
          </>
        ) : (
          <>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.claimwrapper}
              >
                <Grid
                  container
                  spacing={2}
                  className={classes.claimdetailswrapper}
                ></Grid>
              </Grid>
            </Grid>
          </>
        )}
      </>
    </>
  );
}

export default ClaimDetails